export default "__VITE_ASSET__DbsbPAXa__"